import { useHookForm } from "mui-react-hook-form-plus";
import { DialogContent, DialogTitle, Typography } from "@mui/material";
import React from "react";
import UpsellTriggers from "../Misc/UpsellTriggers";
import { FormStepProps } from "../SwiperStepperActions";
import { MenuModel, ProductModel } from "../../../../store/api/upsellApi";
import FormStep from "../../modernTS/Forms/FormStep";

export type UpsellTriggersData = {
  triggers: {
    products: ProductModel[];
    menus: MenuModel[];
  };
};

export function UpsellAddTriggersStep(formStepProps: FormStepProps) {
  const hookForm = useHookForm<UpsellTriggersData>({
    reValidateMode: "onChange",
    criteriaMode: "all",
    defaultValues: {
      triggers: {
        products: [],
        menus: [],
      },
    },
  });

  return (
    <FormStep form={hookForm} {...formStepProps}>
      <DialogTitle>Choose what triggers the upsell</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 4 }} variant={"body1"}>
          An upsell is shown to the customer when they&apos;re about to add a product to their cart.
          <br />
          <br />
          Select the product and/or menus that should trigger the upsell.
        </Typography>
        <UpsellTriggers />
      </DialogContent>
    </FormStep>
  );
}
